import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    details: string;
    ctaText: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Banner title shown when an account update requires a page reload */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountUpdateAlertBanner.title?c=2ulf8o9yqz65y", defaultMessage: "Page Refresh Required" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Banner details shown when an account update requires a page reload */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountUpdateAlertBanner.details?c=26uysh4fh5y6y", defaultMessage: "Refresh to get the latest updates and avoid unexpected issues." }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA button label to reload the page */
            ctaText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountUpdateAlertBanner.ctaText?c=1puqd2rlfznwc", defaultMessage: "Refresh Now" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
